// Scroll yapıldığında popup ın control ile kaymasını sağlar.

export function getPopupContainer(trigger: any) {
	const scrollableArea = trigger.closest('.bcScrollableArea');
	return scrollableArea?.childNodes?.[1]?.firstChild || trigger.parentNode;
}
